import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";

type ImagePreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  image?: string | null;
};

const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
  isOpen,
  onClose,
  image,
}) => {
  if (!image) return null;

  return (
    <Modal isOpen={isOpen} size="md" onClose={onClose} isCentered>
      <ModalOverlay bg="none" backdropFilter="auto" backdropBlur="10px" />
      <ModalContent>
        <ModalCloseButton className="img-preview-modal-close-btn" />
        <ModalBody className="img-preview-modal-body">
          <img src={image} alt="Preview" style={{ width: "100%" }} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ImagePreviewModal;
